
import { Logout, Settings, VpnKey } from '@mui/icons-material'; // Agregamos icono para la contraseña
import { ListItemIcon, Menu, MenuItem, Divider } from '@mui/material';
import React from 'react';
import { useValue } from '../../context/ContextProvider';
import useCheckToken from '../../hooks/useCheckToken';
import Profile from './Profile';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../../store/appStore.tsx';
import ChangePassword from './ChangePassword.js';

// Opcional: Importa aquí tu componente para cambiar contraseña cuando lo crees
// import ChangePassword from './ChangePassword';

const UserMenu = ({ anchorUserMenu, setAnchorUserMenu }) => {
    const { currentUser, clearUser } = useAppStore(appStore => appStore);
    
    useCheckToken(); // Para verificar que el Token del usuario no haya expirado
    const navigate = useNavigate();

    const { state: { }, dispatch } = useValue();

    const handleCloseUserMenu = () => {
        setAnchorUserMenu(null);
    }

    return (
        <>
            <Menu
                anchorEl={anchorUserMenu}
                open={Boolean(anchorUserMenu)}
                onClick={handleCloseUserMenu}
                onClose={handleCloseUserMenu}
            >
                {/* 1. Botón de Perfil (Datos personales) habilitado para TODOS */}
                <MenuItem
                    onClick={() => dispatch({ type: 'UPDATE_PROFILE', payload: { open: true, file: null, photoURL: currentUser?.photoURL } })}
                >
                    <ListItemIcon>
                        <Settings fontSize='small' />
                    </ListItemIcon>
                    Perfil
                </MenuItem>

                {/* 2. Botón de Cambiar Contraseña SOLO para usuarios que NO son de Google */}
                {!currentUser?.google && (
                    <MenuItem
                        onClick={() => {
                            // Aquí lanzas el modal para cambiar la contraseña
                            // Asegúrate de agregar 'OPEN_PASSWORD_MODAL' a tu Context/Reducer
                            dispatch({ type: 'OPEN_PASSWORD_MODAL', payload: {open: true}}); 
                        }}
                    >
                        <ListItemIcon>
                            <VpnKey fontSize='small' />
                        </ListItemIcon>
                        Cambiar Contraseña
                    </MenuItem>
                )}

                <Divider />

                <MenuItem
                    onClick={() => {
                        dispatch({ type: 'UPDATE_USER', payload: null });
                        clearUser();
                        //console.log("Logout");
                        navigate('/');
                    }}
                >
                    <ListItemIcon>
                        <Logout fontSize='small' />
                    </ListItemIcon>
                    Cerrar Sesión
                </MenuItem>
            </Menu>

            {/* Componente para actualizar datos personales */}
            <Profile />

            {/* Componente para actualizar contraseña */}
            <ChangePassword />

            
            {/* 3. Renderizas tu nuevo componente para el cambio de contraseña */}
            {/* <ChangePassword /> */}
        </>
    )
}

export default UserMenu;